export default {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
};
